import { render, staticRenderFns } from "./Section_List.vue?vue&type=template&id=9a38e350&scoped=true&"
import script from "./Section_List.vue?vue&type=script&lang=js&"
export * from "./Section_List.vue?vue&type=script&lang=js&"
import style0 from "./Section_List.vue?vue&type=style&index=0&id=9a38e350&scoped=true&lang=css&"
import style1 from "./Section_List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a38e350",
  null
  
)

export default component.exports